import type { IOpportunityConfiguration } from './OpportunityConfiguration.interface';

export default class OpportunityConfiguration implements IOpportunityConfiguration {
  name: string;
  template: string;
  referral: string;

  static build = (data: IOpportunityConfiguration) => new OpportunityConfiguration(data);
  static blank = () => new OpportunityConfiguration();

  /**
   * Constructor
   * @param {IOpportunityConfiguration} data
   */
  constructor(data?: IOpportunityConfiguration) {
    this.name = data?.name || '';
    this.template = data?.template || '';
    this.referral = data?.referral || '';
  }
}
